<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.newsletter.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.newsletter.list.title"></app-i18n>
      </h1>

      <app-newsletter-list-toolbar></app-newsletter-list-toolbar>
      <app-newsletter-list-filter></app-newsletter-list-filter>
      <app-newsletter-list-table></app-newsletter-list-table>
    </div>
  </div>
</template>

<script>
import NewsletterListFilter from '@modules/newsletter/components/newsletter-list-filter.vue';
import NewsletterListTable from '@modules/newsletter/components/newsletter-list-table.vue';
import NewsletterListToolbar from '@modules/newsletter/components/newsletter-list-toolbar.vue';

export default {
  name: 'app-newsletter-list-page',

  components: {
    [NewsletterListFilter.name]: NewsletterListFilter,
    [NewsletterListTable.name]: NewsletterListTable,
    [NewsletterListToolbar.name]: NewsletterListToolbar,
  },
};
</script>

<style>
</style>
